import { z } from '@customerio/hydra-validation';

// The retired AI usage and Inbox preview usage tabs kept their date range in bare `start`, `end`
// and `granularity` parameters. The Usage tab scopes them per card, so a redirect renames them to
// keep the range of an old link. A value that is not a string is dropped, and the card falls back
// to its default range.
const legacyRangeSchema = z.object({
  start: z.string().optional().catch(undefined),
  end: z.string().optional().catch(undefined),
  granularity: z.string().optional().catch(undefined),
});

function parseLegacyRange(search: unknown) {
  const result = legacyRangeSchema.safeParse(search);
  if (result.success) {
    return result.data;
  }
  return {};
}

export function aiUsageSearch(search: unknown) {
  const range = parseLegacyRange(search);
  return { open: 'ai-usage', aiStart: range.start, aiEnd: range.end, aiGranularity: range.granularity };
}

export function inboxPreviewUsageSearch(search: unknown) {
  const range = parseLegacyRange(search);
  return { open: 'inbox-preview-usage', ipStart: range.start, ipEnd: range.end };
}
